export default "__VITE_ASSET__CUMi6LSO__"